exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] .XqX5_UR5WATkrjGN7Yt9S{padding-bottom:0!important}.XqX5_UR5WATkrjGN7Yt9S .ms-BasePicker-input{height:26px!important}.XqX5_UR5WATkrjGN7Yt9S .ms-BasePicker-text{min-height:unset!important}", ""]);
// Exports
exports.locals = {
	"smallWellWrapperOverride": "XqX5_UR5WATkrjGN7Yt9S"
};